import { localStorageAsync } from "#app/lib/local-storage";

const IMPERSONATION_KEY = "impersonation_session";

export interface StoredImpersonation {
  accessToken: string;
  expiresAt: string;
  user: { userId: string; name?: string; email?: string };
  workspace: { id: string; name: string; urlPath: string };
  returnWorkspaceId: string | null;
}

export function isImpersonationExpired(session: StoredImpersonation): boolean {
  return new Date(session.expiresAt).valueOf() <= Date.now();
}

export async function getStoredImpersonation(): Promise<StoredImpersonation | null> {
  try {
    const raw = await localStorageAsync.getItem(IMPERSONATION_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredImpersonation;
    return parsed.accessToken && parsed.expiresAt && parsed.workspace?.id ? parsed : null;
  } catch {
    return null;
  }
}

export async function setStoredImpersonation(session: StoredImpersonation): Promise<void> {
  await localStorageAsync.setItem(IMPERSONATION_KEY, JSON.stringify(session));
}

export async function clearStoredImpersonation(): Promise<void> {
  await localStorageAsync.removeItem(IMPERSONATION_KEY).catch(() => {});
}
